import { p as proxyCustomElement, H, h, d as Host } from './p-BJEvNVLM.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";

const CosmosIconMegaphone$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconMegaphone extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: 'ce67a0eb560b0363e474f983195c5caddf9b9d7d', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: 'b01f5156941ea4adace89a70bb3e372158966d60', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: 'cc002dcaa974f3f2c325dd81d9193997f0dd826d', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M12.867 1.908c.078-.268.333-.461.603-.395 2.389.624 4.133 1.538 5.353 3.685s1.189 4.103.502 6.474a.5.5 0 0 1-.614.355l-.47-.133a.5.5 0 0 1-.355-.616c.566-1.98.635-3.527-.382-5.319s-2.41-2.433-4.4-2.962a.49.49 0 0 1-.351-.607zm-.356 4.099.128-.504c.06-.227.3-.43.56-.381 1.193.33 2.244 1.19 2.857 2.285.614 1.096.858 2.367.516 3.556a.48.48 0 0 1-.586.338l-.478-.142a.524.524 0 0 1-.342-.593c.138-.707.03-1.663-.373-2.43-.424-.717-1.153-1.325-1.944-1.545a.504.504 0 0 1-.338-.584m-4.625-.784L5.14 9.587 2.006 11.59a1.967 1.967 0 0 0-.736 2.707l.735 1.111c.556.948 1.54 1.64 2.503 1.093l.656-.35 1.275 2.23a1.267 1.267 0 0 0 1.717.454c.546-.31.722-1.008.375-1.6L7.154 15.09l.884-.47 5.489.379a.495.495 0 0 0 .405-.742l-1.47-2.552c.573-.61.705-1.539.261-2.297a1.99 1.99 0 0 0-2.121-.932L8.74 5.247a.507.507 0 0 0-.855-.024", fill: "currentColor" }))));
    }
    static get style() { return cosmosIconCss; }
}, [1, "cosmos-icon-megaphone", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-megaphone"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-megaphone":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconMegaphone$1);
            }
            break;
    } });
}

const CosmosIconMegaphone = CosmosIconMegaphone$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconMegaphone, defineCustomElement };
